import React from "react";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";
import logo from "../assets/images/The Safai Wala 2.png";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-[#0464a4] text-gray-100 pt-12 pb-6">
      <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 md:grid-cols-4 gap-10">
        {/* Logo and Description */}
        <div>
          <img src={logo} alt="Safaiwala Logo" className="w-20 mb-4" />
          <p className="text-sm leading-6 text-gray-200">
            Professional cleaning services you can trust.
            We deliver spotless results for homes, offices, and industries
            with eco-friendly products.
          </p>

          {/* Social Media Icons */}
          <div className="flex gap-4 mt-4">
            <a
              href="https://www.facebook.com/yourpage"
              target="_blank"
              rel="noopener noreferrer"
              className="w-9 h-9 flex items-center justify-center rounded-full bg-[#e58505] text-[#0464a4] hover:bg-white transition"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://twitter.com/yourprofile"
              target="_blank"
              rel="noopener noreferrer"
              className="w-9 h-9 flex items-center justify-center rounded-full bg-[#e58505] text-[#0464a4] hover:bg-white transition"
            >
              <FaTwitter />
            </a>
            <a
              href="https://www.instagram.com/yourprofile"
              target="_blank"
              rel="noopener noreferrer"
              className="w-9 h-9 flex items-center justify-center rounded-full bg-[#e58505] text-[#0464a4] hover:bg-white transition"
            >
              <FaInstagram />
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="text-xl font-semibold text-[#e58505] mb-4">
            Quick Links
          </h3>
          <ul className="space-y-2 text-sm">
            <li>
              <Link to="/" className="hover:text-[#e58505] transition">
                Home
              </Link>
            </li>
            <li>
              <Link to="/about" className="hover:text-[#e58505] transition">
                About Us
              </Link>
            </li>
            <li>
              <Link to="/service" className="hover:text-[#e58505] transition">
                Services
              </Link>
            </li>
            <li>
              {/* <Link to="/contact" className="hover:text-[#e58505] transition">
                Contact
              </Link> */}
            </li>
          </ul>
        </div>

        {/* Services */}
        <div>
          <h3 className="text-xl font-semibold text-[#e58505] mb-4">
            Our Services
          </h3>
          <ul className="space-y-2 text-sm">
            <li>
              <Link to="/" className="hover:text-[#8e8d50] transition">
                Home Deep Cleaning
              </Link>
            </li>
            <li>
              <Link to="/" className="hover:text-[#8e8d50] transition">
                Washroom Cleaning
              </Link>
            </li>
            <li>
              <Link to="/" className="hover:text-[#8e8d50] transition">
                Hall Cleaning
              </Link>
            </li>
            <li>
              <Link to="/" className="hover:text-[#8e8d50] transition">
                Kitchen Cleaning
              </Link>
            </li>
          </ul>
        </div>

        {/* Contact Info */}
        <div>
          <h3 className="text-xl font-semibold text-[#e58505] mb-4">
            Contact Us
          </h3>

          <p className="flex items-center gap-2 text-sm mb-2">
            <FaEnvelope className="text-[#e58505]" />
            <a
              href="mailto:support@thesafaiwala.com"
              className="hover:underline"
            >
              support@thesafaiwala.com
            </a>
          </p>


          <p className="flex items-center gap-2 text-sm mb-2">
            <FaPhoneAlt className="text-[#e58505]" />
            <a href="tel:+919111411500" className="hover:underline">
              +91-919111411500
            </a>
          </p>

          {/* Email (optional) */}
          {/* 
          <p className="flex items-center gap-2 text-sm mb-4">
            <FaEnvelope className="text-[#e58505]" />
            <a
              href="mailto:thesafaiwalaglobal@gmail.com"
              className="hover:underline"
            >
              thesafaiwalaglobal@gmail.com
            </a>
          </p> 
          */}
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="mt-8 border-t border-[#34c3e3] text-center text-sm pt-4">
        © {new Date().getFullYear()}{" "}
        <span className="text-[#e58505] font-semibold">TheSafaiwala</span>. All
        rights reserved. Design & Developed By Yashsoft Solution
      </div>
    </footer>
  );
}
